<template>
  <label class="select-all-label">
    <input
      v-model="checked"
      v-focus
      type="checkbox"
      :indeterminate="isIndeterminate"
      aria-label="Sélectionner tout ou désélectionner tout"
    />
    <i
      v-focus
      tabindex="0"
      :class="iconClass"
      role="checkbox"
      :aria-checked="isIndeterminate ? 'mixed' : checked"
      @keydown.enter.prevent="toggleChecked"
    ></i>
    Sélection : <slot></slot>
  </label>
</template>

<script setup>
import { computed } from "vue";
const checked = defineModel("checked", { type: Boolean });
const props = defineProps({ isSomeSelected: Boolean });

const isIndeterminate = computed(() => props.isSomeSelected && !checked.value);
const iconClass = computed(() => {
  if (checked.value) return "fa-solid fa-square-check";
  if (isIndeterminate.value) return "fa-solid fa-square-minus";
  return "fa-regular fa-square";
});

const toggleChecked = () => {
  checked.value = !checked.value;
};
</script>

<style scoped lang="scss">
.select-all-label {
  cursor: pointer;
  &:hover i {
    background-color: var(--clr-p2);
    font-weight: 400;
  }
}

input[type="checkbox"] {
  display: none;
}

i {
  border-radius: 6px;
  margin-right: 2px;
  padding: 3px;
  color: var(--clr-p7);
  font-size: 17px;
}
</style>
